import { useSelector, useDispatch } from "react-redux";
import { useEffect, useRef } from "react";

import { RootState } from "../store/store";
import { setErrors } from "../store/ui/ui";
import { ValidationErrors } from "../shared/interfaces/ui";

export default function useAppointValidation() {
    const dispatch = useDispatch();

    const isEditAppointment = useSelector(
        (state: RootState) => state.ui.isEditAppointment,
    );

    const newAppointment = useSelector(
        (state: RootState) => state.appointments.newAppointment,
    );
    const existAppointment = useSelector(
        (state: RootState) => state.appointments.existtAppointment,
    );

    const patientId = isEditAppointment
        ? existAppointment.patientId
        : newAppointment.patientId;
    const doctorId = isEditAppointment
        ? existAppointment.doctorId
        : newAppointment.doctorId;
    const startTime = isEditAppointment
        ? existAppointment.startTime
        : newAppointment.startTime;
    const endTime = isEditAppointment
        ? existAppointment.endTime
        : newAppointment.endTime;

    const isTouched = useRef(false);
    function validate(): ValidationErrors {
        isTouched.current = true;

        const newErrors: ValidationErrors = {
            patientName: undefined,
            doctorName: undefined,
            startTime: undefined,
            endTime: undefined,
        };

        if (!patientId) {
            newErrors.patientName = {
                message: "Оберіть пацієнта (обов'язково)",
            };
        }

        if (!doctorId) {
            newErrors.doctorName = { message: "Оберіть лікаря (обов'язково)" };
        }

        if (!startTime) {
            newErrors.startTime = { message: "Виберіть час початку" };
        }

        if (!endTime) {
            newErrors.endTime = { message: "Виберіть час закінчення" };
        }

        dispatch(setErrors(newErrors));

        return newErrors;
    }
    function resetValidation() {
        isTouched.current = false;
        dispatch(
            setErrors({
                patientName: undefined,
                doctorName: undefined,
                startTime: undefined,
                endTime: undefined,
            }),
        );
    }
    useEffect(() => {
        if (isTouched.current) {
            validate();
        }
    }, [patientId, doctorId, startTime, endTime]);

    return { validate, resetValidation };
}
